<template>
  <v-container fluid>
    <v-row class="justify-center">
      <v-col v-if="$page.props.jetstream.managesProfilePhotos || $page.props.jetstream.canUpdateProfileInformation" md="6" sm="12">
        <ProfileInformation
          :user="user"
        />
      </v-col>
      <v-col v-if="$page.props.jetstream.canUpdatePassword" md="6" sm="12">
        <ProfilePassword
          :user="user"
        />
      </v-col>
      <v-col v-if="$page.props.jetstream.hasTeamFeatures">
        <ProfileTeams :user="user" />
      </v-col>
      <v-col v-if="$page.props.jetstream.canManageTwoFactorAuthentication" md="6" sm="12">
        <ProfileTwoFactor
          :user="user"
        />
      </v-col>
      <v-col md="6" sm="12">
        <ProfileSessions
          :sessions="sessions"
        />
      </v-col>
      <v-col v-if="$page.props.jetstream.hasAccountDeletionFeatures" md="6" sm="12">
        <ProfileDelete />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import ProfileInformation from '@/Components/Profile/Information'
import ProfilePassword from '@/Components/Profile/Password'
import ProfileTwoFactor from '@/Components/Profile/TwoFactorAuthentication'
import ProfileSessions from '@/Components/Profile/Sessions'
import ProfileDelete from '@/Components/Profile/Delete'
import ProfileTeams from '@/Components/Profile/Teams'

export default {
   metaInfo: { title: 'Settings' },

   components: {
      ProfileInformation,
      ProfilePassword,
      ProfileTwoFactor,
      ProfileSessions,
      ProfileDelete,
      ProfileTeams
   },

   layout: (h, page) => h(Layout, [page]),

   props: {
      user: {
         type: Object,
         required: true
      },
      sessions: {
         type: Array,
         required: true
      },
   },

   data: () => ({
      //
   }),
}
</script>
